export default __webpack_public_path__ + "navigation-examples-waypoint-arrival-screen-1200-cc50eff7cd90ad623e6a7b7b645b08b9.png";